/* save cache for components rendered */
module.exports = global.config = {
  key: 'R9p_!fC*pRiP@t6HVQQKfqJWphcKJWBwQwdte7-@QefTbhC3JpvBtTsD_3afV6Kxvm.qgrrmkN2K6sG6LV3zdzsDY8-Jxi*nZ2__',
  locale: 'ca'
}
